/* COMPONENT IMPORTS*/
import { ErrorPage } from "../../components/ErrorPage/ErrorPage";
import authentication from "../../msalb2creact";
import authenticationsaml from "../../msalb2creact";
import DetailsList from "../../components/Listing/DetailsList";
import DownloadList from "../../components/Listing/DownloadList";
import { Advantages } from "../../components/CartaoAssociado/Advantages";
import { CardSection } from "../../components/CartaoAssociado/CardSection";
import { Loading } from "../../components/Loading/Loading";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { NavLink } from "react-router-dom";
import {
  ReactPlugin,
  withAITracking,
} from "@microsoft/applicationinsights-react-js";

/* MODULE IMPORTS */
import React, { Component } from "react";
import pdfIconImg from "../../images/pdfIcon.svg";
import downloadImg from "../../images/download.png";

var reactPlugin = new ReactPlugin();

export class ColunaDireita extends Component {
  static displayName = ColunaDireita.name;

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="coluna-direita-wrapper">
        <div className="lista-descricao">{this.props.description}</div>
        <div className="lista-pdf-link">
          <img
            src={pdfIconImg}
            alt=""
            height="26px"
            width="26px"
          />
          <div>
            <div className="glossary-title">Candidatos e Programa</div>
            <a
              className="glossary-download-button"
              href={this.props.pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>Clique aqui</div>
              <img
                src={downloadImg}
                alt="Botão de Download"
                height="7.5px"
                width="7.2px"
              />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default withAITracking(reactPlugin, ColunaDireita);
